export default {
  chamadaBuffer: [],
};